module.exports = __webpack_public_path__ + "img/confuse.25e645df.png";